﻿// This script is released to the public domain and may be used, modified and
// distributed without restrictions. Attribution not necessary but appreciated.
// Source: http://weeknumber.net/how-to/javascript 

// Returns the ISO week of the date.
Date.prototype.getWeek = function () {
    var date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                          - 3 + (week1.getDay() + 6) % 7) / 7);
}

//Date.prototype.getWeek = function() {
//    var determinedate = new Date();
//    determinedate.setFullYear(this.getFullYear(), this.getMonth(), this.getDate());
//    var d = determinedate.getDay();
//    if (d === 0) {
//         d = 7;
//    }
//    determinedate.setDate(determinedate.getDate() + (4 - d));
//    var yn = determinedate.getFullYear();
//    var zbdoCy = Math.floor((determinedate.getTime() - new Date(yn, 0, 1, -6)) / 86400000);
//    var wn = 1 + Math.floor(zbdoCy / 7);
//    return wn;
//}

// Returns the four-digit year corresponding to the ISO week of the date.
Date.prototype.getWeekYear = function () {
    var date = new Date(this.getTime());
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    return date.getFullYear();
}

// Fjerner tidsangivelser..
Date.prototype.getDateWithoutTime = function() {
    var date = new Date(this.getTime());
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}

Date.prototype.formatDate = function (dateFormat) {
    var date = new Date(this.getTime());
    return $.datepicker.formatDate(dateFormat, date);
}

Date.prototype.addDays = function (days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
}

Date.prototype.setWeek = function (weekNumber) {
    var date = new Date(this.getTime()).getDateWithoutTime();
    date.setMonth(0);
    date.setDate(1);

    //Find første dag i ugen;
    var weeknumbers = [6, 0, 1, 2, 3, 4, 5];
    while (weeknumbers[date.getDay() % 7] > 0) {
        date = date.addDays(-1);
    }

    //604 800 000 is a week in miliseconds.. Magic numbers!
    var calculatedWeek = date.getTime() + 604800000 * (weekNumber - 1);
    this.setTime(calculatedWeek);
    
    if(weekNumber == 53 && this.getWeek() == 1) {
        this.setTime(this.getTime() - 604800000);
    }
}